// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// magaza.ecuador@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBd1nCeSfQ1AMeuEK-1emAtJtUA6E6NyII",
    authDomain: "magazalogde.firebaseapp.com",
    projectId: "magazalogde",
    storageBucket: "magazalogde.firebasestorage.app",
    messagingSenderId: "708606966584",
    appId: "1:708606966584:web:8cd781532cec76ea971fcd",
    measurementId: "G-J7G4KZNJE7"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)